var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 1H21.3C22.7906 1 24 2.17578 24 3.625V26.375C24 27.8242 22.7906 29 21.3 29H8.7C7.20938 29 6 27.8242 6 26.375V3.625C6 2.17578 7.20938 1 8.7 1ZM15 27.25C15.9956 27.25 16.8 26.468 16.8 25.5C16.8 24.532 15.9956 23.75 15 23.75C14.0044 23.75 13.2 24.532 13.2 25.5C13.2 26.468 14.0044 27.25 15 27.25ZM8.7 21.3438C8.7 21.7047 9.00375 22 9.375 22H20.625C20.9963 22 21.3 21.7047 21.3 21.3438V4.28125C21.3 3.92031 20.9963 3.625 20.625 3.625H9.375C9.00375 3.625 8.7 3.92031 8.7 4.28125V21.3438Z",
    fill: "#5686E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.40b25c57c5f457c2306b4ed921c42ea1.svg";
export { ForwardRef as ReactComponent };